import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchActivecarinfo } from './activecarinfoAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: {},
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};


// Async thunk to fetch data with filters
export const fetchActivecarinfoDataWithFilters = createAsyncThunk(
  'activecarinfo/fetchActivecarinfoDataWithFilters',
  async ({ filter = {}, options = {} }) => {
    const response = await fetchActivecarinfo({ filter, options }); // Pass filters to the API    
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const ActivecarinfoSlice = createSlice({
  name: 'activecarinfo',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivecarinfoDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchActivecarinfoDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data[action.payload?.results?.[0]?.vin || 0] = action.payload.results?.[0] || { currentSoc: 0, state: '', vin: '' }; // Store the fetched data
      })
      .addCase(fetchActivecarinfoDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectActivecarinfoData = (state) => state.activecarinfo.data;
export const selectActivecarinfoStatus = (state) => state.activecarinfo.status;
export const selectActivecarinfoError = (state) => state.activecarinfo.error;

export default ActivecarinfoSlice.reducer;
